export default __webpack_public_path__ + "static/media/1780.a30b8f97.png";